var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBigLocationSensia = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 85,
  height: 119,
  viewBox: "0 0 85 119",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M42.4997 0.684387C19.1184 0.684387 0.208008 19.5948 0.208008 42.9761C0.208008 68.1698 26.9122 102.909 37.908 116.141C40.3247 119.041 44.7351 119.041 47.1518 116.141C58.0872 102.909 84.7913 68.1698 84.7913 42.9761C84.7913 19.5948 65.8809 0.684387 42.4997 0.684387ZM42.4997 58.0802C34.1622 58.0802 27.3955 51.3136 27.3955 42.9761C27.3955 34.6386 34.1622 27.8719 42.4997 27.8719C50.8372 27.8719 57.6038 34.6386 57.6038 42.9761C57.6038 51.3136 50.8372 58.0802 42.4997 58.0802Z",
  fill: "#162C2B"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBigLocationSensia);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/big-location-sensia.8d9575b8524af40aa4a6abbd11f9c775.svg";